import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class AdminSectionsNewRoute extends Route {
  // Services
  @service breadcrumb;

  // Hooks
  model() {
    return this.breadcrumb.findRouteModelOrCreateRecord('section');
  }

  afterModel(model) {
    this.breadcrumb.registerDetailRoute(model);
  }
}
